import React, {Component} from 'react';

import LocalStorage from '../service/LocalStorage';

class ShoppingCart extends Component {

  constructor(props) {
    super(props);
    let checkStorage = LocalStorage.get('mac-items');
    if(checkStorage !== undefined){
      checkStorage = checkStorage.filter(it => this.checkDateRange(it.savedAt));
      if(checkStorage.length === 0){
        LocalStorage.delete('mac-items');
        checkStorage = undefined;
      }else{
        LocalStorage.put('mac-items', checkStorage);
      }
    }

    this.state = {
      number: checkStorage !== undefined ? checkStorage.length : 0,
    };

    if (this.props.setUpdateCart !== undefined) {
      this.props.setUpdateCart(this.updateState);
    }
    this.shakeNumber = false;
  }

  checkDateRange(timeAt){
    let auxDate = new Date();
    let savedAt = new Date(timeAt);
    auxDate.setHours(0,0,0,0);
    savedAt.setHours(0,0,0,0);
    let auxDif = auxDate.getTime() - savedAt.getTime();
    if(auxDif>=0 && auxDif<=604800000){// 7 días
      return true;
    }
    return false;
  }

  updateState = () => {
    const number = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items').length : 0;
    this.shakeNumber = true;
    this.setState({ number: number });
  }

  goShoppingCart = () => {
    window.location.href = '/mapaalacarta/ShoppingCart';
  }

  render() {
    const { number } = this.state;
    if (number > 0) {
      let classNumber = 'shoppingcart-number';
      if(this.shakeNumber){
        classNumber+= ' shakeNumberToo';
        this.shakeNumber = false;
      }
      return (
        <div className='shoppingcart-container' onClick={this.goShoppingCart}>
          <div className='shoppingcart-icon'>
            <span>
              <i className="mc-basket mc-3x"></i>
            </span>
          </div>
          <div key={'refAnim1-'+new Date().getTime()} className={classNumber}>
            <span>{number}</span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default ShoppingCart;
